__turbopack_context__.v({
  "item": "styles-module-scss-module__2O9xza__item",
  "root": "styles-module-scss-module__2O9xza__root",
  "tileContainer": "styles-module-scss-module__2O9xza__tileContainer",
  "title": "styles-module-scss-module__2O9xza__title",
});
